// extracted by mini-css-extract-plugin
export default {"resume-viewer__download":"styles_resume-viewer__download__Dvwyj","resumeViewerDownload":"styles_resume-viewer__download__Dvwyj"};